import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BULK_CALENDAR_CANCELLATION_WARNING_TEXT } from './bulk-action-modal.texts';

interface IProps {
    count: number;
    className?: string;
}

const CalendarCancellationWarning = ({ count, className }: IProps) => (
    <p className={className}>
        <FormattedMessage
            {...BULK_CALENDAR_CANCELLATION_WARNING_TEXT}
            values={{
                count: count,
                span: (chunks: React.ReactNode) => <span className='alert-message--danger'>{chunks}</span>,
            }}
        />
    </p>
);

export { CalendarCancellationWarning };
